/** Extracts the file extension (last one) from a file name */
export function getExtension(filename: string): string | undefined {
  if (filename) {
    const parts = filename.split('.');

    return parts.length > 1 ? parts.pop() : undefined;
  }

  return undefined;
}

/** Separates filename into base name and extension */
export function parseFilename(filename: string) {
  const extension = getExtension(filename);

  if (!extension) {
    return { baseName: filename, extension: '' };
  }

  // Remove the extension and the dot
  const baseName = filename.slice(0, -(extension.length + 1));

  return { baseName, extension: `.${extension}` };
}
